import r from "../../shared-lib/braze-shared-lib.js";
import y from "../common/base-provider.js";
import e from "../managers/braze-instance.js";
import { STORAGE_KEYS as o } from "../managers/storage-manager.js";
import u from "../managers/subscription-manager.js";
import { randomInclusive as tt } from "../util/math.js";
import b from "../util/net.js";
import {
  newFeatureFlagFromJson as st,
  newFeatureFlagFromSerializedValue as it
} from "./feature-flag-factory.js";
export default class er extends y {
  constructor(t, s, i) {
    super(),
      (this.si = t),
      (this.ei = s),
      (this.ri = i),
      (this.hi = []),
      (this.oi = 0),
      (this.si = t),
      (this.ei = s),
      (this.ri = i),
      (this.ni = null),
      (this.ai = new u()),
      (this.fi = 10),
      (this.ui = null),
      (this.li = null),
      e.jt(this.ai);
  }
  Rs(t) {
    if ((!this.si || this.si.ci()) && null != t && t.feature_flags) {
      this.hi = [];
      for (const s of t.feature_flags) {
        const t = st(s);
        t && this.hi.push(t);
      }
      (this.oi = new Date().getTime()), this.mi(), this.ai.St(this.hi);
    }
  }
  pi() {
    let t = {};
    this.ri && (t = this.ri.I(o.q.di));
    const s = {};
    for (const i in t) {
      const e = it(t[i]);
      e && (s[e.id] = e);
    }
    return s;
  }
  Ws(t) {
    return this.ai.ut(t);
  }
  refreshFeatureFlags(t, s, i = !1, e = !0) {
    if (!this.gi(i))
      return (
        !this.ni &&
          this.si &&
          (this.ni = this.si.Fi(() => {
            this.refreshFeatureFlags(t, s);
          })),
        void ("function" == typeof s && s())
      );
    if ((e && this.yi(), !this.ei)) return void ("function" == typeof s && s());
    const r = this.ei.Ps({}, !0),
      h = this.ei.Bs(r, !1, !0);
    let o = !1;
    this.ei.Gs(r, () => {
      this.ei
        ? b.Hs({
            url: `${this.ei.Ks()}/feature_flags/sync`,
            headers: h,
            data: r,
            S: i => {
              if (!this.ei.Os(r, i, h))
                return (o = !0), void ("function" == typeof s && s());
              this.ei.Qs(), this.Rs(i), "function" == typeof t && t();
            },
            error: t => {
              this.ei.Vs(t, "retrieving feature flags"),
                (o = !0),
                "function" == typeof s && s();
            },
            wi: () => {
              if (e && o && !this.li) {
                let e = this.ui;
                (null == e || e < 1e3 * this.fi) && (e = 1e3 * this.fi),
                  this.bi(Math.min(3e5, tt(1e3 * this.fi, 3 * e)), t, s, i);
              }
            }
          })
        : "function" == typeof s && s();
    });
  }
  yi() {
    null != this.li && (clearTimeout(this.li), (this.li = null));
  }
  bi(t = 1e3 * this.fi, s, i, e) {
    this.yi(),
      (this.li = window.setTimeout(() => {
        this.refreshFeatureFlags(s, i, e);
      }, t)),
      (this.ui = t);
  }
  gi(t) {
    if (!this.si) return !1;
    if (!t) {
      const t = parseFloat(this.si.ji());
      let s = !1;
      if (!isNaN(t)) {
        if (-1 === t) return r.D.info("Feature flag refreshes not allowed"), !1;
        s = new Date().getTime() >= (this.oi || 0) + 1e3 * t;
      }
      if (!s)
        return (
          r.D.info(`Feature flag refreshes were rate limited to ${t} seconds`),
          !1
        );
    }
    return this.si.ci();
  }
  mi() {
    if (!this.ri) return;
    const t = {};
    for (const s of this.hi) {
      const i = s.ss();
      t[s.id] = i;
    }
    this.ri.B(o.q.di, t), this.ri.B(o.q.vi, this.oi);
  }
}
